import React, { useEffect, useRef, useState } from "react";
import { animated, useScroll } from "@react-spring/web";
import '../styles/Contact-style.css';
const contact = () => {
    return (
        <main id="main-contact">
            <animated.div id={"contact"} className="contact">
                <div className="contact-content">
                    <div className="contact-form">
                        <h3 id="form-title">Send me a message</h3>
                        <div className="contact_form">
                            <form action="https://formspree.io/f/myyrgpbn" method="POST">
                                <div className="form-field">
                                    <label htmlFor="email">Email
                                        <input type="email" name="email" id="email" required/>
                                    </label>
                                </div>
                                <div className="form-field">
                                    <label htmlFor="message">Message
                                        <textarea name="message" id="message" cols="60" rows="10" required></textarea>
                                    </label>
                                </div>
                                <div className="contact_form__submit">
                                    <button id={"form-btn"} type="submit">Send</button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="contact-info">
                        <h3>Email Me At </h3>
                        <a href="mailto:kinzelinr@gmail.com"><p>kinzelinr@gmail.com</p></a>
                        <h3>Find Me On </h3>
                        <div className="contact-links">
                            <a href={"https://www.linkedin.com/in/remy-kinzelin-129a1b1a0/"}><i className="fab fa-linkedin"></i></a>
                            <a href={"https://github.com/SLATTY54"}><i className="fab fa-github"></i></a>
                        </div>
                    </div>
                </div>

            </animated.div>
        </main>
    )
};

export default contact